import { ICON_TYPES } from '../constants';

export const IconClose = (): JSX.Element => {
  return (
    <svg viewBox="0 0 22.385 22.385">
      <path
        d="M60.607,991.756a2,2,0,0,0-2.828,0L50,999.534l-7.778-7.778a2,2,0,0,0-2.829,2.828l7.778,7.778-7.778,7.778a2,2,0,1,0,2.828,2.828L50,1005.191l7.778,7.778a2,2,0,0,0,2.829-2.828l-7.778-7.778,7.778-7.778a2,2,0,0,0,0-2.828Z"
        transform="translate(-38.808 -991.17)"
      />
    </svg>
  );
};

IconClose.iconType = ICON_TYPES.ICON_CLOSE;
